import { getCookie } from '../../cookies'
import type { AnalyticsService, EventParameters } from '../analytics-service'
import type { AnalyticsEventName } from '../events'
import { ANALYTICS_EVENTS } from '../events'

export const DEV_ANALYTICS_CUSTOM_EVENT = 'dev-analytics-log-event' as const
export const DEV_ANALYTICS_COOKIE_NAME = 'dev-analytics-events' as const

export type DevAnalyticsLogEntry = {
  name: string
  parameters: EventParameters
  id: number
}

// Custom event listened to by libs/shared/components/organisms/config-editor/dev-analytics/dev-analytics-listener.tsx
// Only fires when the analytics toggle is on
const dispatchLogEvent = (
  name: AnalyticsEventName,
  parameters: EventParameters
) => {
  if (getCookie(DEV_ANALYTICS_COOKIE_NAME) !== 'on') {
    return
  }
  window.dispatchEvent(
    new CustomEvent(DEV_ANALYTICS_CUSTOM_EVENT, {
      detail: { name, parameters },
    })
  )
}

export class DevAnalyticsService implements AnalyticsService {
  logEvent(name: AnalyticsEventName, parameters: EventParameters) {
    dispatchLogEvent(name, parameters)
  }

  setUserId(id: string) {
    dispatchLogEvent(ANALYTICS_EVENTS.SET_USER, { userId: id })
  }
}
